import { ReviewTypes } from "../types/reviewTypes";

// export const reviewsData: ReviewTypes[] = [
//     {
//         id: 1,
//         image: require('../assets/nestfin/r1.jpg'),
//         name: "John Doe",
//         rating: 4.5,
//         title: "Great Experience",
//         description: "I really enjoyed this product. The quality is exceptional, and the customer service was top-notch. Highly recommend!"
//     },
//     {
//         id: 2,
//         image: require('../assets/nestfin/r2.jpg'),
//         name: "Jane Smith",
//         rating: 5.0,
//         title: "Excellent Quality!",
//         description: "This is exactly what I needed! The product arrived quickly and works perfectly. I will definitely be purchasing again."
//     },
//     {
//         id: 3,
//         image: require('../assets/nestfin/r3.jpg'),
//         name: "Sarah Lee",
//         rating: 3.5,
//         title: "Good, but could improve",
//         description: "The product is decent, but it could use a few enhancements. The material could be softer, and the sizing was a bit off."
//     },
//     {
//         id: 4,
//         image: require('../assets/nestfin/r1.jpg'),
//         name: "Michael Brown",
//         rating: 4.0,
//         title: "Satisfactory",
//         description: "I am happy with the purchase. The product is good, and it meets expectations. However, the delivery was slightly delayed."
//     },
//     {
//         id: 5,
//         image: require('../assets/nestfin/r2.jpg'),
//         name: "Emily Davis",
//         rating: 4.8,
//         title: "Fantastic Product!",
//         description: "Absolutely love this! The quality is outstanding, and it was very easy to use. Worth every penny!"
//     },
//     {
//         id: 6,
//         image: "https://randomuser.me/api/portraits/men/4.jpg",
//         name: "David Wilson",
//         rating: 2.0,
//         title: "Not What I Expected",
//         description: "The product didn’t live up to my expectations. It’s not as described, and I had issues with its performance. Very disappointing."
//     },
//     {
//         id: 7,
//         image: require('../assets/nestfin/r3.jpg'),
//         name: "Olivia Martinez",
//         rating: 4.2,
//         title: "Good Value",
//         description: "The product is a good value for the price. It's not perfect, but it gets the job done. I'll consider buying again if needed."
//     },
//     {
//         id: 8,
//         image: require('../assets/nestfin/r1.jpg'),
//         name: "James Taylor",
//         rating: 5.0,
//         title: "Love It!",
//         description: "One of the best purchases I've made. It works exactly as advertised and has exceeded my expectations. Highly recommended!"
//     },
//     {
//         id: 9,
//         image: require('../assets/nestfin/r2.jpg'),
//         name: "Sophia Harris",
//         rating: 4.3,
//         title: "Very Satisfied",
//         description: "I am very happy with the product. It arrived on time and works great. The quality is solid, and I’ll buy more in the future."
//     },
//     {
//         id: 10,
//         image: require('../assets/nestfin/r3.jpg'),
//         name: "Chris White",
//         rating: 3.0,
//         title: "Okay, but could be better",
//         description: "The product is okay, but I expected better. The build quality could be improved, and the instructions weren’t clear."
//     }
// ];



export const reviewsData: ReviewTypes[] = [
    {
        id: 1,
        image: require('../assets/nestfin/r4.png'),
        name: "Vikas Kumar",
        rating: 4.5,
        title: "Perfect PG for Students",
        description: "Had a great experience living here. The room was clean and well-maintained, and the landlord was very cooperative. Highly recommended for working professionals."
    },
    {
        id: 2,
        image: require('../assets/nestfin/r5.png'),
        name: "Ramesh Kumar",
        rating: 5.0,
        title: "Perfect PG for Students",
        description: "This PG is just what I needed. Quiet environment, high-speed internet, and homely food made my stay very pleasant. Would definitely suggest this to fellow students."
    },
    {
        id: 4,
        image: require('../assets/nestfin/r6.png'),
        name: "Pramod Verma",
        rating: 4.0,
        title: "Value for Money",
        description: "Affordable and well-located PG. Facilities were up to the mark, but water supply issues occurred occasionally. Overall, a good deal."
    },
    {
        id: 5,
        image: require('../assets/nestfin/r2.jpg'),
        name: "Reena Yadav",
        rating: 4.8,
        title: "Amazing Experience!",
        description: "The best PG I’ve stayed in! Super clean, friendly management, and the meals felt like home-cooked food. Highly satisfied with the services."
    }
];

